/**
 * A constant denoting whether or not study notes are available
 **/

export type StudyNoteFilter = { isPresent: boolean; label: string };

export const STUDY_NOTE_FILTER: {
  PRESENT: StudyNoteFilter;
  ABSENT: StudyNoteFilter;
} = {
  PRESENT: {
    isPresent: true,
    label: 'Personal Notes',
  },
  ABSENT: {
    isPresent: false,
    label: 'Without Personal Notes',
  },
};
